import axios from "axios"

export const getCdnCreativeImages = async (imgLink) => {
  return await axios.get(imgLink, {
    responseType: "blob",
  })
}
